import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-unit',
  templateUrl: './unit.component.html',
  styleUrls: ['./unit.component.css']
})
export class UnitComponent implements OnInit {
    unitNo;

    public propertyClassesButtons: FormButton[] = [{ id: 'list', icon: 'fa fa-bars', type: 'primary', goto: 'propertyclasses' }];

    public edit?: Edit;

    public selectListPropertyClasses: PropertyClassItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.unitNo = this.stateService.getStateParams()['unit_no'];
    }

    private async loadEdit() {
        if (!!this.unitNo) {
            this.edit = (await this.datatask.Post(602, { unit_no: this.unitNo }))[0];
        }
    }

    private async loadPropertyClasses() {
        this.selectListPropertyClasses = await this.datatask.Post(604);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(605, this.edit))[0];

                if (response?.status_no !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.status_message
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(608, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    public async findBaseUnitName() {
        if (!this.edit) return;

        const baseUnitName = this.selectListPropertyClasses.find((item) => item.propertyclass_id === this.edit!.propertyclass_id)?.base_unit_name ?? '';

        if (!!baseUnitName) {
            this.edit.base_unit_name = baseUnitName;
        } else {
            this.edit.base_unit_name = '';
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'propertyclass_id':
                this.findBaseUnitName();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        await this.loadPropertyClasses();
        this.findBaseUnitName();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    unit_no: string;
    unit_name: string;
    tbf_unit_name: string;
    propertyclass_id: string;
    iso1000_unit_id: string;
    quantity_pr_base_unit: string;
    quantity_formel: string;
    isactive: string;
    base_unit_name: string;
}

interface PropertyClassItem {
    propertyclass_id: string;
    propertyclass_name: string;
    base_unit_name: string;
    orderby: string;
}
